import { State } from '../../reducers/rootReducer'
import CarlineGroup from '../../../entities/CarlineGroup'

const activeCarlineGroupIdSelector = (state: State): CarlineGroup['id'] => state.carlineSelection.activeGroupId

export default activeCarlineGroupIdSelector
